import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FaHistory, FaStar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const RECENT_SEARCHES_KEY = 'recentSearchesV2';

const RecentSearchesModal = ({ shouldShow, setModalVisible, onResumeSearch, locations = [] }) => {
  const [recent, setRecent] = React.useState([]);
  const { t, i18n } = useTranslation();
  const rtl = i18n.dir() === 'rtl';

  // Utility: get location name by code
  const getLocationName = (code) => {
    if (!Array.isArray(locations)) return code;
    const loc = locations.find(l => String(l.locationCode) === String(code));
    return loc ? loc.locationName : code;
  };

  // Utility: format date
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const [d, t] = dateStr.split('T');
    return `${d} ${t}`;
  };

  React.useEffect(() => {
    try {
      const stored = sessionStorage.getItem(RECENT_SEARCHES_KEY);
      setRecent(stored ? JSON.parse(stored) : []);
    } catch {
      setRecent([]);
    }
  }, [shouldShow]);

  return (
    <Modal show={shouldShow} onHide={() => setModalVisible(false)} centered dir={rtl ? 'rtl' : 'ltr'}>
      <Modal.Header closeButton className={rtl ? 'text-right' : ''}>
        <Modal.Title className={rtl ? 'w-100 text-right' : ''}><FaHistory style={{marginBottom: 3}}/> {t('recentSearches')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={rtl ? 'text-right' : ''}>
        {recent.length === 0 && <div>{t('noRecentSearches')}</div>}
        {recent.map((r, idx) => {
          const { params } = r;
          const fromLocationName = getLocationName(params?.fromLocationCode);
          const toLocationName = getLocationName(params?.toLocationCode);
          const sameLocations = fromLocationName === toLocationName;
          const showAge = params?.age && params.age != 30;
          // Determine if this is the current search
          const isCurrentSearch = JSON.stringify(params) === JSON.stringify(recent[0]?.params);
          return (
            <div key={r.searchKey || idx} className={
              `d-flex align-items-center justify-content-between border-bottom py-2${rtl ? ' flex-row-reverse' : ''}`
            }>
              <div style={{marginRight: rtl ? 0 : 12, marginLeft: rtl ? 12 : 0}}>
                <div>
                  <b>{fromLocationName}</b>
                  {!sameLocations && (
                    <>
                      {rtl ? ' ← ' : ' → '}
                      <b>{toLocationName}</b>
                    </>
                  )}
                </div>
                <div style={{fontSize: '0.95em', color: '#666'}}>
                  {formatDate(params?.startDate)} - {formatDate(params?.endDate)}
                  {showAge && <span> | {t('driverAgeText')}: {params.age}</span>}
                </div>
              </div>
              <div className={`d-flex flex-column align-items-center${rtl ? ' flex-row-reverse' : ''}`} style={{minWidth: 110}}>
                <Button size="sm" variant="outline-primary" className="position-relative" onClick={() => !isCurrentSearch && onResumeSearch(params)} disabled={isCurrentSearch} style={{minWidth: 90}}>
                  {t('resumeSearch')}
                </Button>
                {isCurrentSearch && <span className="text-muted mt-1" style={{fontSize: '0.9em'}}>{t('currentSearch') || 'Current search'}</span>}
              </div>
            </div>
          );
        })}
      </Modal.Body>
      <Modal.Footer className={rtl ? 'text-right' : ''}>
        <Button variant="secondary" onClick={() => setModalVisible(false)}>
          {t('close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RecentSearchesModal;
